'use client';

import { useTranslations } from 'next-intl';
import { Button } from '@/src/shared/ui/button';
import { getGoogleAuthUrl } from '@/src/shared/api/auth/googleAuthUrl';

function GoogleLogo() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className="size-4">
      <path
        fill="#4285F4"
        d="M23.49 12.28c0-.79-.07-1.54-.2-2.28H12v4.31h6.46a5.53 5.53 0 0 1-2.39 3.63v3.01h3.88c2.27-2.09 3.54-5.17 3.54-8.67Z"
      />
      <path
        fill="#34A853"
        d="M12 24c3.24 0 5.96-1.07 7.95-2.9l-3.88-3.01c-1.08.72-2.46 1.15-4.07 1.15-3.13 0-5.78-2.11-6.72-4.95H1.27v3.1A12 12 0 0 0 12 24Z"
      />
      <path
        fill="#FBBC05"
        d="M5.28 14.29A7.18 7.18 0 0 1 4.9 12c0-.79.14-1.55.38-2.29v-3.1H1.27A12 12 0 0 0 0 12c0 1.94.47 3.78 1.27 5.39l4.01-3.1Z"
      />
      <path
        fill="#EA4335"
        d="M12 4.76c1.76 0 3.34.61 4.58 1.8l3.43-3.43A11.4 11.4 0 0 0 12 0 12 12 0 0 0 1.27 6.61l4.01 3.1c.94-2.84 3.59-4.95 6.72-4.95Z"
      />
    </svg>
  );
}

export function GoogleSignInButton() {
  const t = useTranslations('auth.social');
  const googleAuthUrl = getGoogleAuthUrl();

  return (
    <Button
      type="button"
      variant="outline"
      className="h-11 w-full rounded-lg border-border/80 bg-background text-[14px] font-medium text-foreground hover:bg-muted/40"
      asChild
    >
      <a href={googleAuthUrl} className="gap-2">
        <GoogleLogo />
        <span>{t('google')}</span>
      </a>
    </Button>
  );
}
